import React, { Component } from 'react'
import { post } from '../../../utils/networking'
import { Route, NavLink, HashRouter } from "react-router-dom";
import * as Notification from '../../../notification'
import $ from 'jquery'
import { configs } from '../../../helpers/constants';
import ReCAPTCHA from 'react-google-recaptcha'
import FacebookProvider, { Login, LoginButton } from 'react-facebook'
import "./style.css"
import * as Notify from '../../../notification'
import StepOne from './stepOne'
import StepTwo from './stepTwo'

export class RegisterForm extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isVerify: false,
            partner: {
                firstName: "",
                lastName: "",
                email: "",
                phone: "",
                password: "",
                confirmPassword: "",
                businessName: "",
                address1: "",
                longtitude: 0,
                latitude: 0,
                categoryID: "",
                zipCode: ""
            },
            name: "",
            address1: "",
            address2: "",
            longtitude: 0,
            latitude: 0,
            categoryId: 1,
            zipCode: 0,
            city: "",
            currentStep: 1,
            isProccessing: false,
            country: ""
        }
    }


    handleRegister() {

        this.setState({
            isProccessing: true
        })
        let {
            address1,
            address2,
            city,
            state,
            country
        } = this.state.partner
        let addressForDisplay = ""
        // addressForDisplay = (address1 ? (address1 + ", ") : "") + (city ? (city + ", ") : "") + (state ? (state + ", ") : "") + (country ? country : "")

        let param = {
            partner: {
                firstName: this.state.partner.firstName,
                lastName: this.state.partner.lastName,
                email: this.state.partner.email,
                phone: this.state.partner.phone,
                password: this.state.partner.password,
                confirmPassword: this.state.partner.confirmPassword
            },
            name: this.state.partner.businessName,
            address1: address1,
            address2: address2,
            longitude: this.state.partner.longtitude,
            latitude: this.state.partner.latitude,
            categoryId: 1,
            zipCode: this.state.partner.zipCode,
            city: this.state.partner.city,
            state: this.state.partner.state,
            country: this.state.partner.country,
        }

        post('user/register', param, "partner", result => {
            Notify.show($("#bt_register"), "Partner register success! Please check your email for login credential.", "success", "1");
            this.setState({
                isRegisted: true,
                isProccessing: false
            })
            setTimeout(() => {
                this.props.history.push('/')
            }, 4000);
        }, errors => {
            Notify.show($("#bt_register"), errors.errors[0], "fail", "0");
            this.setState({
                isProccessing: false
            })
        })
    }

    stepBack(value) {
        if (!value) return
        this.setState({
            partner: value,
            currentStep: 1
        })
    }

    render() {
        // $("html, body").animate({ scrollTop: 0 }, 400);
        return (
            <div id="partner_register_page" className="partner_page">
                <div className="partner_page_detail">
                    <ul className="breadcrumbs">
                        {
                            (this.state.currentStep === 1) ? <li className="unavailable acctive">Step 1 <span>: Get Started</span></li> : <li className="unavailable">Step 1 <span>: Get Started</span></li>
                        }
                        <li className="space">|</li>
                        {
                            (this.state.currentStep === 2) ? <li className="unavailable acctive">Step 2 <span>: Business Info</span></li> : <li className="unavailable">Step 2 <span>: Business Info</span></li>
                        }
                    </ul>
                    {
                        (this.state.currentStep === 2 && this.state.partner.firstName != "") ? <StepTwo callback={(value) => {
                            this.setState({
                                partner: {
                                    ...this.state.partner,
                                    businessName: value.businessName,
                                    address1: value.address1,
                                    address2: value.address2,
                                    longtitude: value.longtitude,
                                    latitude: value.latitude,
                                    categoryID: value.categoryID,
                                    zipCode: value.zipCode,
                                    city: value.city,
                                    state: value.state,
                                    country: value.country
                                }
                            }, () => {
                                this.handleRegister()
                            })
                        }}
                            stepBack={(partner) => this.stepBack(partner)}
                            partnerData={this.state.partner}
                            isProccessing={this.state.isProccessing}
                        /> : <StepOne callback={(value) => {
                            this.setState({
                                partner: {
                                    ...this.state.partner,
                                    firstName: value.firstName,
                                    lastName: value.lastName,
                                    email: value.email,
                                    phone: value.phone,
                                    password: value.password,
                                    confirmPassword: value.confirmPassword
                                }
                                , currentStep: 2
                            })
                        }
                        }
                            partnerData={this.state.partner}
                            />
                    }
                </div>
            </div>
        )
    }
}
export default RegisterForm


// WEBPACK FOOTER //
// ./src/components/partner/register/index.js